import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class NavigationGuard implements CanActivate {
    private startPage = false;

    constructor( private router: Router ) {
        this.startPage = router.getCurrentNavigation().extras.state?.from === 'startpage';
    }

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // This will check if the start page does not exist in the routes
        if ( this.startPage ) {
            localStorage.removeItem('__rerouter__');

            this.router.navigate(['manage']);

            return false;
        }

        const ss = localStorage.getItem('__rerouter__');

        if (!ss) {
            localStorage.setItem('__rerouter__', state.url);
            const m = state.url.split('/');

            this.router.navigate([ m.length > 0 ? m[0] : '' ]);
        } else {
            localStorage.removeItem('__rerouter__');
            this.router.navigate([ 'manage' ]);
        }

        return false;
    }
}